function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WithdrawTemplate = require('./withdraw.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoContacts = require('./../../modals/saito-contacts/saito-contacts');
var Withdraw = /*#__PURE__*/function () {
  function Withdraw(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Withdraw);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.contacts = new SaitoContacts(app, mod);
    this.ticker = '';
    this.pc = null; // pointer at the crypto module
    this.publicKey = '';
    this.fee = null;
    this.errors = {
      amount: false,
      address: false
    };

    // We will only programattically input the address if it is a Saito PublicKey
    this.app.connection.on('saito-crypto-withdraw-render-request', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.ticker = (obj === null || obj === void 0 ? void 0 : obj.ticker) || '';
              _this.publicKey = (obj === null || obj === void 0 ? void 0 : obj.address) || '';
              if (!_this.ticker) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this.app.wallet.setPreferredCrypto(_this.ticker);
            case 1:
              _this.render();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return _createClass(Withdraw, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var destination;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.pc = this.app.wallet.returnPreferredCrypto();
              this.ticker = this.pc.ticker;
              destination = '';
              if (!this.publicKey) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.pc.returnAddressFromPublicKey(this.publicKey);
            case 1:
              destination = _context2.v;
            case 2:
              if (document.getElementById('withdrawal-form')) {
                this.app.browser.replaceElementById(WithdrawTemplate(this.app, this.mod, this.publicKey, destination), 'withdrawal-form');
              } else {
                this.overlay.show(WithdrawTemplate(this.app, this.mod, this.publicKey, destination), function () {
                  _this2.ticker = null;
                  _this2.pc = null;
                  _this2.publicKey = null;
                });
              }
              _context2.n = 3;
              return this.loadCryptos();
            case 3:
              document.querySelector('.withdraw-info-value.balance').innerHTML = "".concat(this.app.browser.formatDecimals(this.pc.returnBalance()));
              document.querySelectorAll("#withdraw-logo-cont img[data-ticker=\"".concat(this.pc.ticker, "\"]")).forEach(function (el) {
                return el.classList.remove('hide-element');
              });
              _context2.n = 4;
              return this.fetchWithdrawFee();
            case 4:
              this.attachEvents();
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "loadCryptos",
    value: function () {
      var _loadCryptos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var available_cryptos, _iterator, _step, crypto_mod, show_me, html, icons, img_html, _t, _t2, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              available_cryptos = this.app.wallet.returnActivatedCryptos(); //
              // Populate drop down menu to change cryptos
              //
              _iterator = _createForOfIteratorHelper(available_cryptos);
              _context3.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context3.n = 6;
                break;
              }
              crypto_mod = _step.value;
              _t = !(this !== null && this !== void 0 && this.publicKey);
              if (_t) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return crypto_mod.returnAddressFromPublicKey(this.publicKey);
            case 3:
              _t2 = _context3.v;
              _t = _t2 !== null;
            case 4:
              if (!_t) {
                _context3.n = 5;
                break;
              }
              show_me = crypto_mod.name == this.pc.name;
              html = "<option ".concat(show_me ? 'selected' : "", " id=\"crypto-option-").concat(crypto_mod.name, "\" value=\"").concat(crypto_mod.ticker, "\">").concat(crypto_mod.ticker, "</option>");
              this.app.browser.addElementToId(html, 'withdraw-select-crypto');
              icons = crypto_mod.returnLogos();
              img_html = "<img class=\"crypto-logo hide-element\" data-ticker=\"".concat(crypto_mod.ticker, "\" src=\"").concat(icons.img, "\">");
              if (icons.sub_logo) {
                img_html += "<img class=\"chain-logo hide-element\" data-ticker=\"".concat(crypto_mod.ticker, "\" src=\"").concat(icons.sub_logo, "\">");
              }
              this.app.browser.addElementToId(img_html, 'withdraw-logo-cont');
            case 5:
              _context3.n = 2;
              break;
            case 6:
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t3 = _context3.v;
              _iterator.e(_t3);
            case 8:
              _context3.p = 8;
              _iterator.f();
              return _context3.f(8);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 7, 8, 9]]);
      }));
      function loadCryptos() {
        return _loadCryptos.apply(this, arguments);
      }
      return loadCryptos;
    }()
  }, {
    key: "attachEvents",
    value: function () {
      var _attachEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this3 = this;
        var this_withdraw;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this_withdraw = this;
              document.querySelector('#withdraw-select-crypto').onchange = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
                  var element;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        element = e.target;
                        document.querySelector('.withdraw-info-value.balance').innerHTML = "fetching...";
                        document.querySelectorAll("#withdraw-logo-cont img").forEach(function (el) {
                          return el.classList.add('hide-element');
                        });
                        document.querySelectorAll("#withdraw-logo-cont img[data-ticker=\"".concat(element.value, "\"]")).forEach(function (el) {
                          return el.classList.remove('hide-element');
                        });
                        _context5.n = 1;
                        return _this3.app.wallet.setPreferredCrypto(element.value);
                      case 1:
                        _this3.fee = null;
                        if (!_this3.publicKey) {
                          _context5.n = 2;
                          break;
                        }
                        _this3.render();
                        return _context5.a(2);
                      case 2:
                        document.querySelector('#withdraw-input-address').value = '';
                        document.querySelector('#withdraw-input-amount').value = '';
                        _this3.resetErrors();
                        _this3.pc = _this3.app.wallet.returnPreferredCrypto();
                        _this3.ticker = _this3.pc.ticker;
                        _context5.n = 3;
                        return _this3.fetchWithdrawFee();
                      case 3:
                        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                          return _regenerator().w(function (_context4) {
                            while (1) switch (_context4.n) {
                              case 0:
                                document.querySelector('.withdraw-info-value.balance').innerHTML = "".concat(_this3.app.browser.formatDecimals(_this3.pc.returnBalance()));
                              case 1:
                                return _context4.a(2);
                            }
                          }, _callee4);
                        })), 500);
                      case 4:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }();
              if (document.querySelector('#withdraw-input-address')) {
                document.querySelector('#withdraw-input-address').onblur = /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
                    return _regenerator().w(function (_context6) {
                      while (1) switch (_context6.n) {
                        case 0:
                          _this3.validateAddressInput();
                          _context6.n = 1;
                          return _this3.fetchWithdrawFee();
                        case 1:
                          return _context6.a(2);
                      }
                    }, _callee6);
                  }));
                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }();
              }
              if (document.querySelector('#withdraw-input-amount')) {
                //#withdraw-input-amount
                document.querySelector('#withdraw-input-amount').onblur = function (e) {
                  _this3.validateAmountInput();
                };

                // Prevent entering non-numeric values...
                document.querySelector('#withdraw-input-amount').onchange = function (e) {
                  var amount = document.querySelector('#withdraw-input-amount').value;
                  _this3.app.browser.validateAmountLimit(amount, e);
                };
              }
              if (document.querySelector('#withdrawal-form') != null) {
                document.querySelector('#withdrawal-form').onsubmit = function (e) {
                  e.preventDefault();
                  _this3.validateAddressInput();
                  _this3.validateAmountInput();
                  if (_this3.errors['amount'] != false || _this3.errors['address'] != false) {
                    return false;
                  }
                  var amount = Number(document.querySelector('#withdraw-input-amount').value);
                  var address = document.querySelector('#withdraw-input-address').value;
                  document.querySelector('.withdraw-confirm-amount').innerText = "".concat(amount, " ").concat(_this3.ticker);
                  document.querySelector('.withdraw-address-1').innerText = address.slice(0, -8);
                  document.querySelector('.withdraw-address-2').innerText = address.slice(-8);
                  document.querySelector('.withdraw-confirm-fee').innerText = "(fee: ".concat(_this3.fee, " ").concat(_this3.ticker, ")");

                  // Change view to confirmation screen
                  document.querySelector('#withdraw-step-one').classList.toggle('hide-element');
                  document.querySelector('#withdraw-step-two').classList.toggle('hide-element');
                };
                document.getElementById('reset-form').onclick = function (e) {
                  _this3.app.connection.emit('saito-crypto-withdraw-render-request');
                };
                document.querySelector('#withdraw-cancel').onclick = function (e) {
                  e.preventDefault();
                  document.querySelector('#withdraw-step-one').classList.toggle('hide-element');
                  document.querySelector('#withdraw-step-two').classList.toggle('hide-element');
                };
                document.querySelector('#withdraw-confirm').onclick = /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
                    var amount, address, ticker, sender, ts, hash, _t4;
                    return _regenerator().w(function (_context8) {
                      while (1) switch (_context8.p = _context8.n) {
                        case 0:
                          e.preventDefault();
                          _context8.p = 1;
                          amount = document.querySelector('#withdraw-input-amount').value;
                          address = document.querySelector('#withdraw-input-address').value;
                          ticker = _this3.ticker;
                          sender = _this3.pc.formatAddress();
                          document.querySelector('.withdraw-msg-icon').classList.toggle('fa-circle-exclamation');
                          document.querySelector('.confirm-msg-container .spinner').classList.add('show');
                          document.querySelector('.withdraw-msg-icon').classList.toggle('hide');
                          document.querySelector('.confirm-submit').style.opacity = 0;
                          document.querySelector('.withdraw-msg-text').innerText = 'Sending';
                          document.querySelector('.withdraw-msg-question').innerText = '...';
                          console.log('network fee:', _this3.fee);
                          ts = new Date().getTime();
                          _context8.n = 2;
                          return _this3.app.wallet.sendPayment(ticker, [sender], [address], [amount], btoa(sender + address + amount + ts), /*#__PURE__*/function () {
                            var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(res) {
                              return _regenerator().w(function (_context7) {
                                while (1) switch (_context7.n) {
                                  case 0:
                                    if (res.hash != '') {
                                      setTimeout(function () {
                                        if (document.querySelector('.confirm-msg')) {
                                          document.querySelector('.confirm-msg').innerHTML = "Your transaction has been broadcast <br > Please check transaction history in the sidebar menu for confirmation";
                                          document.querySelector('.confirm-msg-container .spinner').classList.remove('show');
                                          document.querySelector('.withdraw-msg-icon').classList.toggle('hide');
                                          document.querySelector('.withdraw-msg-icon').classList.toggle('fa-circle-check');
                                        }
                                      }, 1000);
                                    } else {
                                      this_withdraw.showError();
                                    }
                                  case 1:
                                    return _context7.a(2);
                                }
                              }, _callee7);
                            }));
                            return function (_x5) {
                              return _ref6.apply(this, arguments);
                            };
                          }(), _this3 === null || _this3 === void 0 ? void 0 : _this3.publicKey);
                        case 2:
                          hash = _context8.v;
                          _context8.n = 4;
                          break;
                        case 3:
                          _context8.p = 3;
                          _t4 = _context8.v;
                          console.error('Send Error: ' + _t4);
                          this_withdraw.showError();
                        case 4:
                          return _context8.a(2);
                      }
                    }, _callee8, null, [[1, 3]]);
                  }));
                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }();
                if (document.querySelector('#withdraw-max-btn') != null) {
                  document.querySelector('#withdraw-max-btn').onclick = /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
                      var amount_avl, thousand_separator, replace, balance_as_float;
                      return _regenerator().w(function (_context9) {
                        while (1) switch (_context9.n) {
                          case 0:
                            if (!document.querySelector('#withdraw-input-amount').disabled) {
                              amount_avl = _this3.pc.returnBalance();
                              thousand_separator = _this3.app.browser.getThousandSeparator();
                              replace = amount_avl.split(thousand_separator).join('');
                              balance_as_float = parseFloat(Number(replace));
                              document.querySelector('#withdraw-input-amount').value = balance_as_float - this_withdraw.fee;
                              this_withdraw.validateAmountInput();
                            }
                          case 1:
                            return _context9.a(2);
                        }
                      }, _callee9);
                    }));
                    return function (_x6) {
                      return _ref7.apply(this, arguments);
                    };
                  }();
                }
                if (document.getElementById('address-book')) {
                  document.getElementById('address-book').onclick = function (e) {
                    _this3.contacts.title = "Contacts with ".concat(_this3.ticker);
                    _this3.contacts.callback = function (key) {
                      _this3.publicKey = key;
                      _this3.render();
                    };
                    var contactsWithCrypto = _this3.app.keychain.returnKeys();
                    if (_this3.ticker !== 'SAITO') {
                      contactsWithCrypto = contactsWithCrypto.filter(function (k) {
                        return (k === null || k === void 0 ? void 0 : k.crypto_addresses) && k.crypto_addresses[_this3.ticker];
                      });
                    }
                    contactsWithCrypto = contactsWithCrypto.map(function (x) {
                      return x.publicKey;
                    });
                    _this3.contacts.render(contactsWithCrypto);
                  };
                }
              }
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function attachEvents() {
        return _attachEvents.apply(this, arguments);
      }
      return attachEvents;
    }()
  }, {
    key: "showError",
    value: function showError() {
      document.querySelector('.confirm-msg').innerHTML = "Transfer request unsuccessful <br > Please try again";
      document.querySelector('.confirm-msg-container .spinner').classList.remove('show');
      document.querySelector('.withdraw-msg-icon').classList.toggle('hide');
      document.querySelector('.withdraw-msg-icon').classList.remove('fa-circle-notch');
      document.querySelector('.withdraw-msg-icon').classList.remove('fa-circle-check');
      document.querySelector('.withdraw-msg-icon').classList.toggle('fa-circle-xmark');
    }
  }, {
    key: "hideSaitoHeaderMenu",
    value: function hideSaitoHeaderMenu() {
      var components = this.mod.components;
      for (var key in components) {
        var _components$key;
        if (((_components$key = components[key]) === null || _components$key === void 0 ? void 0 : _components$key.slug) == 'SaitoHeader') {
          var saito_header = components[key];
          saito_header.hideMenu();
        }
      }
    }
  }, {
    key: "fetchWithdrawFee",
    value: function () {
      var _fetchWithdrawFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _this4 = this;
        var this_withdraw, address;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this_withdraw = this;
              address = document.querySelector('#withdraw-input-address').value;
              document.querySelector('.withdraw-info-value.fee').innerHTML = 'updating...';
              this.pc.checkWithdrawalFeeForAddress(address, function (amt) {
                _this4.fee = Number(amt);
                document.querySelector('.withdraw-info-value.fee').innerHTML = "".concat(amt, " ").concat(_this4.ticker);
              });
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function fetchWithdrawFee() {
        return _fetchWithdrawFee.apply(this, arguments);
      }
      return fetchWithdrawFee;
    }()
  }, {
    key: "validateAmountInput",
    value: function validateAmountInput() {
      this.clearAmountError();
      var amount = document.querySelector('#withdraw-input-amount').value;
      var error_msg = null;
      if (amount != '') {
        amount = Number(amount);
        var amount_avl = Number(this.pc.returnBalance());
        this.fee = Number(this.fee);
        if (amount <= 0) {
          error_msg = 'Error: Amount should be greater than 0';
        } else if (amount > amount_avl) {
          error_msg = "Error: Insufficent funds ( ".concat(amount_avl, " ").concat(this.ticker, " available)");
        } else if (amount + this.fee > amount_avl) {
          error_msg = "Error: Your withdrawal amount + transaction fee exceeds available balance. Please reduce the amount to cover withdrawal fee.";
        }
      } else {
        error_msg = 'Error: No input';
      }
      if (error_msg) {
        this.errors['amount'] = true;
        document.querySelector('#withdraw-amount-error').innerHTML = error_msg;
        document.querySelector('#withdraw-amount-error').style.display = 'block';
      }
      this.handleErrors();
    }
  }, {
    key: "validateAddressInput",
    value: function validateAddressInput() {
      this.clearAddressError();
      var address = document.querySelector('#withdraw-input-address').value;
      var valid = this.pc.validateAddress(address);
      if (!valid) {
        document.querySelector('#withdraw-address-error').innerHTML = 'Error: Invalid ' + this.ticker + ' address';
        document.querySelector('#withdraw-address-error').style.display = 'block';
        this.errors['address'] = true;
      }

      // Disable submission
      this.handleErrors();
    }
  }, {
    key: "handleErrors",
    value: function handleErrors() {
      if (this.errors['amount'] != false || this.errors['address'] != false) {
        document.querySelector('#saito-overlay-submit').classList.add('disabled');
      } else {
        document.querySelector('#saito-overlay-submit').classList.remove('disabled');
      }
    }
  }, {
    key: "clearAddressError",
    value: function clearAddressError() {
      this.errors['address'] = false;
      document.querySelector('#withdraw-address-error').innerHTML = '';
      document.querySelector('#withdraw-address-error').style.display = 'none';
    }
  }, {
    key: "clearAmountError",
    value: function clearAmountError() {
      // reset errors
      this.errors['amount'] = false;
      document.querySelector('#withdraw-amount-error').innerHTML = '';
      document.querySelector('#withdraw-amount-error').style.display = 'none';
    }
  }, {
    key: "resetErrors",
    value: function resetErrors() {
      this.errors = {
        amount: false,
        address: false
      };
      this.clearAddressError();
      this.clearAmountError();
      this.handleErrors();
    }
  }]);
}();
module.exports = Withdraw;